import {inject, Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {getSupportedLanguage} from "../utils/ui.utils";
import moment from "moment";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private translate = inject(TranslateService);
  private language$ = new BehaviorSubject<string>(getSupportedLanguage());

  private applyLanguage(language: string) {
    const supportedLanguage = getSupportedLanguage(language);
    this.translate.use(supportedLanguage);
    this.language$.next(supportedLanguage);
    moment.locale(supportedLanguage);
    document.documentElement.setAttribute('dir', supportedLanguage === 'ar' ? 'rtl' : 'auto');
  }

  setLanguage(language: string) {
    this.applyLanguage(language);
  }

  getLanguage() {
    return this.language$.getValue();
  }
}
